import {
  InvoiceTask,
  UpdateInvoiceInput,
  UpdateQuoteInput,
} from '__generated__/GQL';
import { InvoiceTaskWithoutTotal } from 'features/Work/types';

const computeTasksDiff = (
  formTasks: InvoiceTaskWithoutTotal[],
  invoiceTasks: Pick<InvoiceTask, 'invoiceTaskId'>[],
) => {
  const createdTasks:
    | UpdateInvoiceInput['createdTasks']
    | UpdateQuoteInput['createdTasks'] = [];
  const updatedTasks: InvoiceTaskWithoutTotal[] = [];

  formTasks.forEach(({ invoiceTaskId: formTaskId, ...formTask }) => {
    const isExistingTask = invoiceTasks.some(
      ({ invoiceTaskId }) => invoiceTaskId === formTaskId,
    );

    if (isExistingTask) {
      updatedTasks.push({ invoiceTaskId: formTaskId, ...formTask });
    } else {
      createdTasks.push({ ...formTask });
    }
  });

  const deletedTaskIds = invoiceTasks
    .filter(
      ({ invoiceTaskId }) =>
        !formTasks.some((formTask) => formTask.invoiceTaskId === invoiceTaskId),
    )
    .map(({ invoiceTaskId }) => invoiceTaskId);

  return {
    createdTasks,
    deletedTaskIds,
    updatedTasks,
  };
};

export default computeTasksDiff;
